import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyAb-Dy-3DvL4jWvQKgNjtxD8WgHvTnd--Y",
  authDomain: "laris-jogja.firebaseapp.com",
  projectId: "laris-jogja",
  storageBucket: "laris-jogja.firebasestorage.app",
  messagingSenderId: "194384813150",
  appId: "1:194384813150:web:198e5a384f419aa197e8cf"
};

const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)